export function normalizeAccept(accept?: string | string[]): string[] {
  if (Array.isArray(accept)) {
    return accept.map(item => item.trim()).filter(Boolean);
  }

  return (
    accept
      ?.split(",")
      .map(item => item.trim())
      .filter(Boolean) ?? []
  );
}

export function doesFileMatchAcceptedType(fileName: string, fileType: string, acceptedType: string): boolean {
  const normalizedFileName = fileName.toLowerCase();
  const normalizedFileType = fileType.toLowerCase();
  const normalizedAcceptedType = acceptedType.toLowerCase();

  if (normalizedAcceptedType.startsWith(".")) return normalizedFileName.endsWith(normalizedAcceptedType);
  if (normalizedAcceptedType.endsWith("/*")) return normalizedFileType.startsWith(normalizedAcceptedType.slice(0, -1));

  return normalizedFileType === normalizedAcceptedType;
}

export function isAcceptedFileType(file: File, acceptedTypes: string[]): boolean {
  if (!acceptedTypes.length) return true;

  return acceptedTypes.some(type => doesFileMatchAcceptedType(file.name, file.type, type));
}
